export default __webpack_public_path__ + "static/media/Check.c4fa93c1.svg";